import { changeFollowStateAction, changeUnfollowModalStateAction } from 'pages/Course/store'
import { connect } from 'react-redux'
import UI from './UI'

const mapStateToProps = ({ course }) => ({
  modalState: course.unfollowCourseModalState
})

const mapDispatchToProps = dispatch => ({
  changeUnfollowModalState: state => dispatch(changeUnfollowModalStateAction(state)),
  changeFollowState: _ => dispatch(changeFollowStateAction())
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
